import React from "react";
import logo from "../../Assets/OG Logo.png";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";

const socialLinks = [
  { icon: FaFacebookF, href: "https://www.facebook.com/yourpage", label: "Facebook" },
  { icon: FaInstagram, href: "https://www.instagram.com/yourpage", label: "Instagram" },
  { icon: FaLinkedinIn, href: "https://www.linkedin.com/yourpage", label: "LinkedIn" },
  { icon: FaYoutube, href: "https://www.youtube.com/yourchannel", label: "YouTube" },
  { icon: FaWhatsapp, href: "https://wa.me/919036011861", label: "WhatsApp" },
];

const quickLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms & Conditions", href: "/terms" },
];

const Footer = () => {
  return (
    <footer className="border-t border-[#e8e4dc] bg-[#fbfaf7] text-[#0D004C]">
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-14 sm:px-8">
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img src={logo} alt="Our Genie Logo" className="mb-4 w-16" />
            <h2 className="text-lg font-extrabold tracking-tight">Our Genie App</h2>
            <p className="mt-3 max-w-[240px] text-sm leading-relaxed text-gray-500">
              Smart home services that bring comfort and care to your doorstep.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="mb-5 text-xs font-extrabold uppercase tracking-[0.2em] text-[#AF7D23]">
              Contact
            </h3>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-center gap-3 text-gray-600">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#e3c477] bg-[#fff8e8] text-[#AF7D23]">
                  <FaPhoneAlt size={12} />
                </span>
                <a href="tel:+919036011861" className="transition hover:text-[#AF7D23]">
                  +91 90360 11861
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-600">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#e3c477] bg-[#fff8e8] text-[#AF7D23]">
                  <FaEnvelope size={12} />
                </span>
                <a href="mailto:contact@ourgenie.net" className="transition hover:text-[#AF7D23]">
                  contact@ourgenie.net
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-600">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#e3c477] bg-[#fff8e8] text-[#AF7D23]">
                  <FaClock size={12} />
                </span>
                <span>9 AM – 9 PM (Mon – Sun)</span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-5 text-xs font-extrabold uppercase tracking-[0.2em] text-[#AF7D23]">
              Quick Links
            </h3>
            <ul className="space-y-3 text-sm">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="group inline-flex items-center gap-1.5 text-gray-600 transition hover:text-[#AF7D23]"
                  >
                    <span className="h-px w-0 bg-[#AF7D23] transition-all duration-200 group-hover:w-2.5" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="mb-5 text-xs font-extrabold uppercase tracking-[0.2em] text-[#AF7D23]">
              Follow Us
            </h3>
            <div className="flex flex-wrap gap-2.5">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-[#0D004C] transition-all duration-200 hover:-translate-y-0.5 hover:border-[#AF7D23] hover:bg-[#fff8e8] hover:text-[#AF7D23]"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-gray-200 pt-6 text-xs text-gray-400 sm:flex-row">
          <span>© {new Date().getFullYear()} Our Genie App. All rights reserved.</span>
        
        </div>
      </div>
    </footer>
  );
};

export default Footer;